module.exports = __webpack_public_path__ + "b894a54f7cc5d4e3c6817f38e98f3818.MP3";